import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "re-widget mb-1" }
const _hoisted_2 = { class: "steppers" }
const _hoisted_3 = {
  key: 0,
  class: "steppers"
}
const _hoisted_4 = { class: "steppers-header mb-3" }
const _hoisted_5 = { style: {"background-color":"#f8f8f8"} }
const _hoisted_6 = { class: "steppers-number" }
const _hoisted_7 = {
  key: 0,
  class: "visually-hidden"
}
const _hoisted_8 = {
  key: 1,
  class: "visually-hidden"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 3,
  class: "icon steppers-success",
  "aria-label": "step eseguito"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("use", {
  href: "/bi-sprites.svg#it-check",
  "xlink:href": "/bi-sprites.svg#it-check"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 4,
  class: "visually-hidden"
}
const _hoisted_14 = {
  class: "steppers-content",
  "aria-live": "polite"
}
const _hoisted_15 = { class: "row d-flex justify-content-center" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  key: 1,
  class: "row d-flex justify-content-center mt-3"
}
const _hoisted_18 = { class: "col-lg-10 col-12" }
const _hoisted_19 = {
  class: "steppers-nav",
  style: {"justify-content":"center"}
}

import { computed, onMounted, ref, inject } from "vue";
import { useToolbar } from "../src/composables/useToolbar";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "./models/Store/store";
import { useI18n } from "vue-i18n";
import { useWidget } from "./composables/useWidget";
import moment from "moment";
import constants from "./models/Utils/constants";
import { KIcon } from "@k-digitale/kappa";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { indexOf } from "lodash";
import { ParametersMadeModel } from "./models/Step/ParametersMadeModel";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const emitter = inject("emitter");
const router = useRouter();
const route = useRoute();
const store = useStore();
const { clock } = useToolbar();
const { t } = useI18n();
const { baseImagePath } = useWidget();
const goToNextButton = ref();
const tenantConfig = useTenantConfig();

const canGoNextStep = ref(false);

clock();
const stepServiceDescription = computed(() => {
    if (store.stepsMade.service) {
        return store.stepsMade.service.name;
    } else return "";
});

const stepLocationDescription = computed(() => {
    if (store.stepsMade.location) {
        return store.stepsMade.location.name;
    } else return "";
});

const stepHourDescription = computed(() => {
    if (store.stepsMade.interval && store.stepsMade.interval.description && store.stepsMade.day && store.stepsMade.month) {
        var startnterval = store.stepsMade.interval.description.split("-")[0].trim();
        var momentDate = moment(`${store.stepsMade.day.day}/${store.stepsMade.month.month}/${store.stepsMade.month.year} ${startnterval}`, "DD/MM/yyyy HH:mm");
        return momentDate.format("LLL");
    } else return "";
});

const reservationSteps = computed(() => [
    {
        index: 1,
        title: t("titles.stepperService"),
        shortTitle: t("titles.stepperServiceShort"),
        description: stepServiceDescription.value
    },
    {
        index: 2,
        title: t("titles.stepperLocation"),
        shortTitle: t("titles.stepperLocationShort"),
        description: stepLocationDescription.value
    },
    {
        index: 3,
        title: t("titles.stepperHour"),
        shortTitle: t("titles.stepperHourShort"),
        description: stepHourDescription.value
    },
    {
        index: 4,
        title: t("titles.stepperPersonalData"),
        shortTitle: "",
        description: ""
    }
]);

onMounted(() => {
    // debugger;
    const localeCode = t("settings.localeCode");
    moment.locale(localeCode);
    emitter.on(constants.CAN_GO_NEXT_STEP, (value: boolean) => {
        canGoNextStep.value = value;
        /*     if (value) {
      scrollToNextButton();
    } */
    });
    emitter.on(constants.SCROLL_TO_NEXT_STEP, () => {
        console.log("received scroll");
        scrollToNextButton();
    });

    const paramsIndex = window.location.href.indexOf("?");
    var queryParamsString = "";
    if (paramsIndex >= 0) {
        queryParamsString = window.location.href.substring(paramsIndex + 1, window.location.href.length);
    }

    const queryParams = new URLSearchParams(queryParamsString);

    const queryObject = {} as any;
    for (const [key, value] of queryParams.entries()) {
        queryObject[key] = value;
    }

    router.push({
        name: "home",
        query: {
            ...queryObject
        }
    });
});

const scrollToNextButton = () => {
    //goToNextButton.value.scrollIntoView({ behavior: "smooth" });
};

const stepperVisible = computed(() => {
    return (
        route.name !== "home" &&
        route.name !== "tenant" &&
        route.name !== "user" &&
        route.name !== "userchoice" &&
        route.name !== "summary" &&
        route.name !== "summaryRecall" &&
        route.name !== "editbook" &&
        route.name !== "editbookresumedata" &&
        route.name !== "deleted" &&
        route.name !== "checkin"
    );
});

const goToNextVisible = computed(() => {
    return route.name !== "bookformchoice" && route.name !== "bookuserdata" && route.name !== "recalluserdata";
});

const previousStepNotVisible = computed(() => {
    return route.name && (route.name === "bookservice" || route.name === "bookservicechoice") && tenantConfig && store.tenantSelected.skipTenantPage && tenantConfig.skipUserChoise.value;
});

const currentStep = computed(() => {
    let numCurrentStep = 1;
    if (store.stepsMade.service) {
        numCurrentStep = 2;
    }
    if (store.stepsMade.location) {
        numCurrentStep = 3;
    }
    if (store.stepsMade.interval) {
        numCurrentStep = 4;
    }
    if (store.bookingSubmitted) {
        numCurrentStep = 5;
    }
    return numCurrentStep;
});

const goToNextStep = () => {
    const focusedElement = document.activeElement;

    if (focusedElement) {
        (focusedElement as any).blur();
    }

    emitter.emit("goNextStep");
};
const goToPreviousStep = () => {
    const focusedElement = document.activeElement;

    if (focusedElement) {
        (focusedElement as any).blur();
    }

    router.go(-1);
    // emitter.emit("goPreviousStep");
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "re-widget-outer",
    class: _normalizeClass(["container-fluid", [{ 'mt-4': !stepperVisible.value }]]),
    style: {"scroll-margin":"80px"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (stepperVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reservationSteps.value, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.index,
                      class: _normalizeClass([
                                    { 'active no-line': currentStep.value === item.index },
                                    { confirmed: currentStep.value > item.index },
                                    { 'py-1': currentStep.value > item.index },
                                    { 'py-3': currentStep.value <= item.index }
                                ])
                    }, [
                      _createElementVNode("span", _hoisted_6, [
                        (currentStep.value === item.index)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Step"))
                          : _createCommentVNode("", true),
                        (currentStep.value === item.index)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Attivo"))
                          : _createCommentVNode("", true),
                        (currentStep.value <= item.index)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.index), 1))
                          : _createCommentVNode("", true),
                        (currentStep.value > item.index)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                          : _createCommentVNode("", true),
                        (currentStep.value > item.index)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Confermato"))
                          : _createCommentVNode("", true)
                      ]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ], 2))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_router_view)
            ])
          ])
        ]),
        (stepperVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("nav", _hoisted_19, [
                  (!previousStepNotVisible.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-outline-primary steppers-btn-prev steppermin",
                        onClick: goToPreviousStep
                      }, [
                        _createVNode(_unref(KIcon), {
                          icon: "it-chevron-left",
                          class: "icon-primary"
                        }),
                        _createTextVNode(_toDisplayString(_unref(t)("common.previous")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (goToNextVisible.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        ref_key: "goToNextButton",
                        ref: goToNextButton,
                        style: {"scroll-margin":"200px"},
                        type: "button",
                        class: _normalizeClass(["btn btn-primary steppers-btn-next steppermin", [canGoNextStep.value ? '' : 'disabled']]),
                        onClick: goToNextStep
                      }, [
                        _createTextVNode(_toDisplayString(_unref(t)("common.next")), 1),
                        _createVNode(_unref(KIcon), {
                          icon: "it-chevron-right",
                          class: "icon-primary"
                        })
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})